import React, { useState, useEffect, useRef } from "react";

const TechnologySection = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRef = useRef(null);
  
  const loopVideos = [
    "/images/Loop1.mp4",
    "/images/Loop2.mp4",
    "/images/Loop3.mp4"
  ];

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleVideoEnd = () => {
        setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % loopVideos.length);
      };
      video.addEventListener('ended', handleVideoEnd);
      return () => video.removeEventListener('ended', handleVideoEnd);
    }
  }, [loopVideos.length]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play();
    }
  }, [currentVideoIndex]);

  const handleVideoClick = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % loopVideos.length);
  };

  return (
    <section className="section technology-section" id="technology">
      <div className="technology-background">
        <div className="loop-container">
          <video autoPlay loop muted playsInline className="loop-video-single">
            <source src="/images/ChocLead3.mp4" type="video/mp4" />
          </video>
        </div>
        
        <div className="technology-overlay">
          <div className="container">
            <p className="tag">Exclusive Technology</p>
            
            <div className="technology-card">
              <div className="technology-layout">
                <div className="technology-content">
                  <h2 className="technology-title">
                    GLOBAL EXCLUSIVE COCONUT MESOCARP FIBRE TECHNOLOGY
                  </h2>
                  
                  <div className="technology-text">
                    <p className="technology-paragraph">
                      Calowry Inc. is the only food company in the world that sources 
                      high-quality coconut mesocarp short and ultrashort fibre for various 
                      industries. We are proud to provide our corporate food partners with 
                      a product that retains essential organoleptic qualities while reducing 
                      calories, carbohydrates, and ingredient costs in every imaginable 
                      chocolate formulation.
                    </p>
                    
                    <p className="technology-paragraph">
                      One of the greatest advantages of coconut mesocarp over any other 
                      existing plant-based short and ultra-short, all-natural fibre currently 
                      on the market, is that 100% of the other fibres are produced via 
                      bleaching the product in extremely caustic, corrosive chemicals such as 
                      peracetic acid, sulfuric acid, and chlorine. In contrast, within 
                      Calowry's manufacturing and purification process for coconut mesocarp, 
                      there is nothing but pure water and a lemon juice component involved.
                    </p>
                  </div>
                </div>

                <div className="loop-video-container" onClick={handleVideoClick}>
                  <video 
                    ref={videoRef}
                    muted 
                    playsInline 
                    className="loop-sequential-video"
                  >
                    <source src={loopVideos[currentVideoIndex]} type="video/mp4" />
                  </video>
                  <div className="video-indicator">
                    {loopVideos.map((_, index) => (
                      <span 
                        key={index} 
                        className={`indicator-dot ${index === currentVideoIndex ? 'active' : ''}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologySection;
